"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumn = exports.Alignment = exports.WidthType = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var _1 = require(".");
var WidthType;
(function (WidthType) {
    WidthType["AUTO"] = "auto";
    WidthType["PX"] = "px";
    WidthType["PERCENT"] = "%";
})(WidthType = exports.WidthType || (exports.WidthType = {}));
var Alignment;
(function (Alignment) {
    Alignment["START"] = "start";
    Alignment["CENTER"] = "center";
    Alignment["END"] = "end";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var TableColumn = function (_a) {
    var children = _a.children, alignment = _a.alignment, ariaColumnIndex = _a.ariaColumnIndex;
    return (React.createElement(_1.TableCell, { isHeader: true, alignment: alignment, ariaColIndex: ariaColumnIndex, ariaRowIndex: 1 }, children));
};
exports.TableColumn = TableColumn;
exports.TableColumn.defaultProps = {
    alignment: Alignment.START,
    widthType: WidthType.AUTO,
    widthValue: 0,
};
exports.TableColumn.propTypes = {
    alignment: PropTypes.oneOf(Object.values(Alignment)),
    ariaColumnIndex: PropTypes.number,
    widthType: PropTypes.oneOf(Object.values(WidthType)),
    widthValue: PropTypes.number,
};
